export var LicenseServerType;
(function (LicenseServerType) {
    LicenseServerType[LicenseServerType["StandardProduction"] = 0] = "StandardProduction";
    LicenseServerType[LicenseServerType["StandardNonProduction"] = 1] = "StandardNonProduction";
    LicenseServerType[LicenseServerType["EnterpriseProduction"] = 2] = "EnterpriseProduction";
    LicenseServerType[LicenseServerType["EnterpriseNonProduction"] = 3] = "EnterpriseNonProduction";
    LicenseServerType[LicenseServerType["Repository"] = 4] = "Repository";
    LicenseServerType[LicenseServerType["DisasterRecovery"] = 5] = "DisasterRecovery";
})(LicenseServerType || (LicenseServerType = {}));
;
